import Immutable from 'immutable'
import type { Action } from 'redux'

import { actionTypes } from 'actions/actionTypes'

export const initialState = Immutable.fromJS({
  wizard: {
    stepNames: null,
    currentStepName: '',
    currentStepNumber: 0,
    isLastStep: false,
  },
  isDiscountAppliedBarDismissed: false,
  isInWizardFunnel: false,
})

const signupReducers = {
  signup: (state = initialState, action: SignupAction) => {
    switch (action.type) {
      case actionTypes.SIGNUP_STEPS_RECEIVE: {
        return state.setIn(['wizard', 'stepNames'], Immutable.fromJS(action.stepNames))
      }

      case actionTypes.SIGNUP_STEP_SET: {
        return state
          .setIn(['wizard', 'currentStepName'], action.currentStepName)
          .setIn(['wizard', 'currentStepNumber'], action.currentStepNumber)
          .setIn(['wizard', 'isLastStep'], action.isLastStep)
      }

      case actionTypes.SIGNUP_DISMISS_DISCOUNT_APPLIED_BAR: {
        return state.set('isDiscountAppliedBarDismissed', true)
      }

      case actionTypes.SIGNUP_SHOW_DISCOUNT_APPLIED_BAR: {
        return state.set('isDiscountAppliedBarDismissed', false)
      }

      case actionTypes.WIZARD_SEEN: {
        return state.set('isInWizardFunnel', true)
      }

      case actionTypes.PAGE_CHANGED: {
        const funnelPaths = ['/menu', '/signup', '/check-out']
        const isInFunnelPage = funnelPaths.some((path) => action.newLocation?.includes(path))

        const isWizardSeen = state.get('isInWizardFunnel')

        return state.set('isInWizardFunnel', isInFunnelPage && isWizardSeen)
      }

      default: {
        return state
      }
    }
  },
}

export { signupReducers }

type SignupAction = Action<string> &
  Partial<{
    currentStepName: string
    currentStepNumber: number
    isLastStep: boolean
    count: number
    newLocation: string
    isDietaryConfirmed: boolean
    isRecipeConfirmed: boolean
    recipePreferences: string[]
    stepNames: string[]
  }>
